<template>
  <div class="min-h-screen pt-24 md:pt-28">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <router-link to="/" class="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium mb-6">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
        Volver al inicio
      </router-link>
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
        <h1 class="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-4">Política de Privacidad</h1>
        <p class="text-sm text-gray-500 mb-8">Última actualización: mayo de 2026</p>
        <div class="prose prose-gray max-w-none">

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Comprometidos a Cuidar tus Datos</h2>
          <p class="text-gray-600 mb-6">
            En este espacio, el usuario, podrá encontrar toda la información relativa a los términos y condiciones legales que definen las relaciones entre los usuarios y nosotros como responsables de esta web. Como usuario, es importante que conozcas estos términos antes de continuar tu navegación.
          </p>
          <p class="text-gray-600 mb-6">
            Prio, como responsable de esta web, asume el compromiso de procesar la información de nuestros usuarios y clientes con plenas garantías y cumplir con los requisitos nacionales que regulan la recopilación y uso de los datos personales de nuestros usuarios. Esta web, por tanto, cumple rigurosamente con la <strong>Ley 25.326 de Protección de Datos Personales</strong> de Argentina.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Finalidades - ¿Con qué finalidades tratamos tus datos?</h2>
          <p class="text-gray-600 mb-4">
            En cumplimiento de lo dispuesto en la Ley 25.326 de Protección de Datos Personales, te informamos de que trataremos los datos que nos facilitas para:
          </p>
          <ul class="list-disc pl-5 text-gray-600 mb-6 space-y-2">
            <li>Gestionar el registro y uso de la Plataforma por parte del usuario</li>
            <li>Procesar los pagos y suscripciones de los servicios contratados</li>
            <li>Gestionar la contratación de servicios que realice a través de la Plataforma, así como la facturación correspondiente</li>
            <li>Procesamiento mediante inteligencia artificial para generación de presupuestos y asistente conversacional</li>
            <li>Transcripción de voz a texto para entrada por audio en el asistente de IA</li>
            <li>Remitir periódicamente comunicaciones sobre servicios, eventos y noticias relacionadas con las actividades desarrolladas por Prio, por cualquier medio (correo electrónico), salvo que se indique lo contrario o el usuario se oponga o revoque su consentimiento</li>
            <li>Remitir información comercial y/o promocional relacionada con el sector de servicios contratados y valor añadido para usuarios finales, salvo que se indique lo contrario o el usuario se oponga o revoque su consentimiento</li>
            <li>Dar cumplimiento a las obligaciones legalmente establecidas, así como verificar el cumplimiento de las obligaciones contractuales, incluida la prevención de fraude</li>
            <li>Cesión de datos a organismos y autoridades, siempre y cuando sean requeridos de conformidad con las disposiciones legales y reglamentarias</li>
          </ul>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Categorías de Datos - ¿Qué datos tratamos?</h2>
          <p class="text-gray-600 mb-4">
            Derivado de las finalidades antes mencionadas, en Prio gestionamos las siguientes categorías de datos:
          </p>
          <ul class="list-disc pl-5 text-gray-600 mb-6 space-y-2">
            <li><strong>Datos identificativos:</strong> nombre, apellido, correo electrónico, número de teléfono</li>
            <li><strong>Datos de navegación:</strong> dirección IP, cookies, información sobre el dispositivo y navegador</li>
            <li><strong>Datos de información comercial:</strong> historial de compras, preferencias de servicios</li>
            <li><strong>Datos de uso:</strong> información sobre cómo interactúas con la Plataforma</li>
            <li><strong>Contenido del usuario:</strong> presupuestos, catálogo de servicios, datos de clientes que cargues</li>
          </ul>
          <p class="text-gray-600 mb-6">
            En caso de que el usuario facilite datos de terceros (datos de sus propios clientes), manifiesta contar con el consentimiento de estos y se compromete a trasladarle la información contenida en esta cláusula, eximiendo a Prio de cualquier responsabilidad en este sentido.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Legitimación - ¿Cuál es la legitimación para el tratamiento de tus datos?</h2>
          <p class="text-gray-600 mb-4">
            El tratamiento de datos cuyo fin es el envío de boletines periódicos (newslettering) sobre servicios, eventos y noticias relacionadas con nuestra actividad profesional se basa en el consentimiento del interesado, solicitado expresamente para llevar a cabo dichos tratamientos, de acuerdo con la normativa vigente.
          </p>
          <p class="text-gray-600 mb-4">
            Además, la legitimación para el tratamiento de los datos relacionados con la prestación de servicios se basa en la ejecución del contrato de servicios que el usuario contrata con Prio.
          </p>
          <p class="text-gray-600 mb-6">
            Por último, los datos se podrán utilizar para dar cumplimiento a las obligaciones legales aplicables a Prio.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Plazo de Conservación de los Datos - ¿Por cuánto tiempo conservaremos tus datos?</h2>
          <p class="text-gray-600 mb-6">
            Prio conservará los datos personales de los usuarios mientras dure la relación contractual y, una vez finalizada, durante un plazo adicional de 2 (dos) años para el cumplimiento de obligaciones fiscales y la defensa de posibles reclamaciones. Transcurrido dicho plazo, los datos serán suprimidos de forma segura. Los datos tratados con base en el consentimiento se conservarán mientras este no sea revocado por el titular.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Destinatarios - ¿A qué destinatarios se comunicarán tus datos?</h2>
          <p class="text-gray-600 mb-4">
            Para operar el servicio, Prio se apoya en los siguientes proveedores terceros que procesan datos personales en nuestro nombre. En cumplimiento del Artículo 11 de la Ley 25.326, se informa la identidad de cada cesionario y la finalidad de la cesión:
          </p>

          <div class="overflow-x-auto mb-4">
            <table class="min-w-full border-collapse border border-gray-200 text-sm">
              <thead>
                <tr class="bg-gray-50">
                  <th class="border border-gray-200 px-4 py-2 text-left font-semibold">Proveedor</th>
                  <th class="border border-gray-200 px-4 py-2 text-left font-semibold">Servicio</th>
                  <th class="border border-gray-200 px-4 py-2 text-left font-semibold">Ubicación</th>
                  <th class="border border-gray-200 px-4 py-2 text-left font-semibold">Datos accedidos</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="border border-gray-200 px-4 py-2">MercadoPago S.A.</td>
                  <td class="border border-gray-200 px-4 py-2">Procesamiento de pagos</td>
                  <td class="border border-gray-200 px-4 py-2">Argentina</td>
                  <td class="border border-gray-200 px-4 py-2">Nombre, email, datos de pago</td>
                </tr>
                <tr class="bg-gray-50">
                  <td class="border border-gray-200 px-4 py-2">Resend Inc.</td>
                  <td class="border border-gray-200 px-4 py-2">Envío de emails</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Dirección de email</td>
                </tr>
                <tr>
                  <td class="border border-gray-200 px-4 py-2">Deepgram Inc.</td>
                  <td class="border border-gray-200 px-4 py-2">Transcripción de voz a texto</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Audio grabado por el usuario</td>
                </tr>
                <tr class="bg-gray-50">
                  <td class="border border-gray-200 px-4 py-2">Google LLC (via OpenRouter)</td>
                  <td class="border border-gray-200 px-4 py-2">Modelo de IA (asistente conversacional)</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Texto de consultas del usuario</td>
                </tr>
                <tr>
                  <td class="border border-gray-200 px-4 py-2">Microsoft Corporation</td>
                  <td class="border border-gray-200 px-4 py-2">Analytics de navegación (Clarity)</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Comportamiento de navegación, clicks, scroll</td>
                </tr>
                <tr class="bg-gray-50">
                  <td class="border border-gray-200 px-4 py-2">Google LLC</td>
                  <td class="border border-gray-200 px-4 py-2">Analytics de navegación (Google Analytics)</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Datos de navegación, páginas visitadas</td>
                </tr>
                <tr>
                  <td class="border border-gray-200 px-4 py-2">Google LLC</td>
                  <td class="border border-gray-200 px-4 py-2">Almacenamiento de imágenes (Cloud Storage)</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Imágenes subidas por el usuario</td>
                </tr>
                <tr class="bg-gray-50">
                  <td class="border border-gray-200 px-4 py-2">Google LLC</td>
                  <td class="border border-gray-200 px-4 py-2">Autenticación (OAuth)</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Nombre, email, foto de perfil (si el usuario opta)</td>
                </tr>
                <tr>
                  <td class="border border-gray-200 px-4 py-2">Google LLC</td>
                  <td class="border border-gray-200 px-4 py-2">Tipografías web (Google Fonts)</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Dirección IP (necesario para carga de recursos)</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p class="text-gray-600 mb-4">
            <strong>Transferencia internacional de datos (Artículo 12, Ley 25.326):</strong> Varios de los proveedores listados se encuentran en Estados Unidos, país que no cuenta con un nivel de protección adecuada reconocido por la legislación argentina. Los datos personales se transfieren a dichos proveedores exclusivamente con el <strong>consentimiento expreso del titular</strong>, otorgado mediante la aceptación de esta Política de Privacidad. El titular puede revocar este consentimiento en cualquier momento, aunque ello podría implicar la imposibilidad de usar ciertas funcionalidades del servicio.
          </p>

          <p class="text-gray-600 mb-4">
            Prio ha suscrito los correspondientes contratos de encargo de tratamiento con cada uno de los proveedores que prestan servicios a Prio, con el objetivo de garantizar que dichos proveedores traten tus datos de conformidad con lo establecido en la legislación vigente.
          </p>
          <p class="text-gray-600 mb-6">
            También podrán ser cedidos a las Fuerzas y Cuerpos de Seguridad del Estado en los casos que exista una obligación legal.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Seguridad de la Información - ¿Qué medidas de seguridad implantamos para cuidar tus datos?</h2>
          <p class="text-gray-600 mb-4">
            Para proteger las diferentes tipologías de datos reflejados en esta política de privacidad llevamos a cabo las medidas de seguridad técnicas necesarias para evitar su pérdida, manipulación, difusión o alteración:
          </p>
          <ul class="list-disc pl-5 text-gray-600 mb-6 space-y-2">
            <li>Encriptación de las comunicaciones entre el dispositivo del usuario y los servidores de Prio (protocolo HTTPS)</li>
            <li>Encriptación de la información sensible en los servidores de Prio</li>
            <li>Autenticación mediante tokens JWT para acceso a la API</li>
            <li>Medidas de control de acceso y auditoría</li>
            <li>Otras medidas que eviten el acceso a los datos del usuario por parte de terceros no autorizados</li>
          </ul>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Derechos ARCO - ¿Cuáles son tus derechos cuando nos facilitas tus datos?</h2>
          <p class="text-gray-600 mb-4">
            La Ley 25.326 otorga a los titulares de datos personales los siguientes derechos:
          </p>
          <ul class="list-disc pl-5 text-gray-600 mb-6 space-y-2">
            <li><strong>Acceso:</strong> derecho a obtener confirmación sobre si en Prio estamos tratando datos personales que te conciernen</li>
            <li><strong>Rectificación:</strong> derecho a acceder a tus datos personales y solicitar la rectificación de los datos inexactos</li>
            <li><strong>Cancelación:</strong> derecho a solicitar la supresión de tus datos cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos</li>
            <li><strong>Oposición:</strong> derecho a oponerte al tratamiento de tus datos por motivos relacionados con tu situación particular</li>
          </ul>
          <p class="text-gray-600 mb-4">
            En determinadas circunstancias, podrás solicitar la limitación del tratamiento de tus datos, en cuyo caso únicamente los conservaremos para el ejercicio o la defensa de reclamaciones.
          </p>
          <p class="text-gray-600 mb-6">
            Asimismo, puedes ejercer el derecho a la portabilidad de los datos, así como retirar los consentimientos facilitados en cualquier momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">¿Cómo ejercer tus derechos?</h2>
          <p class="text-gray-600 mb-4">
            Si deseas hacer uso de cualquiera de tus derechos puedes dirigirte a:
          </p>
          <ul class="list-none pl-0 text-gray-600 mb-6 space-y-2">
            <li><strong>Email:</strong> hola@prio.ar</li>
            <li><strong>Asunto:</strong> Ejercicio derechos ARCO - Ley 25.326</li>
          </ul>
          <p class="text-gray-600 mb-6">
            Por último, te informamos que puedes dirigirte ante la <strong>Agencia de Acceso a la Información Pública (AAIP)</strong> y demás organismos públicos competentes para cualquier reclamación derivada del tratamiento de tus datos personales.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Modificación de la Política de Privacidad</h2>
          <p class="text-gray-600 mb-6">
            Prio podrá modificar la presente Política de Privacidad en cualquier momento, siendo publicadas las sucesivas versiones en el Sitio Web. En cualquier caso, Prio comunicará con previo aviso las modificaciones de la presente política que afecten a los usuarios a fin de que puedan aceptar las mismas.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">Responsable del Tratamiento</h2>
          <div class="bg-gray-50 rounded-lg p-4 mb-6">
            <p class="text-gray-600 mb-2"><strong>Denominación:</strong> [Denominación social de la SAS — a definir]</p>
            <p class="text-gray-600 mb-2"><strong>CUIT:</strong> [COMPLETAR]</p>
            <p class="text-gray-600 mb-2"><strong>Domicilio legal:</strong> Ciudad Autónoma de Buenos Aires, Argentina</p>
            <p class="text-gray-600 mb-2"><strong>Sitio Web:</strong> prio.ar</p>
            <p class="text-gray-600 mb-2"><strong>Email:</strong> hola@prio.ar</p>
            <p class="text-gray-600">Registro de base de datos ante la AAIP: En trámite</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { useScrollReveal } from '@/composables/useScrollReveal';
useScrollReveal();

useHead({
  title: 'Política de Privacidad - Prio',
  meta: [
    { name: 'description', content: 'Política de privacidad de Prio - Protección de datos personales' },
  ],
});
</script>
